import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { GitlabLogoIcon } from './GitlabIcon';
import BitwardenLogoIcon from './bitwarden.svg';
import ConfluenceLogoIcon from './confluence-seeklogo.com.svg';
import DownloadManagerLogoIcon from './file-download-1.svg';
import JiraLogoIcon from './jira-1.svg';
import OILogoIcon from './open-webui.svg';
import XxLogoIconRund from './xx-Logoicon-Verlauf-rund.svg';
import { Link, List, ListRow } from '@backstage/ui';



export default function ToolkitCard() {
  return (
        <List aria-label="Tools list" items={[
                {
                  label: 'Gitlab',
                  url: 'https://gitlab.exxcellent.de/',
                  icon: <GitlabLogoIcon />,
                  description: 'Internal Gitlab contains specially secured projects.'
                },
                {
                  label: 'Gitlab Ext',
                  url: 'https://gitlab-ext.exxcellent.de/',
                  icon: <GitlabLogoIcon allBlack />,
                  description: 'External Gitlab contains externally (internet) accessible projects.'
                },
                {
                  label: 'Bitwarden',
                  url: 'https://vault.corp.exxcellent.de/#/login/',
                  icon: <img style={{width: '30px', height: 'auto', color: 'white'}} src={BitwardenLogoIcon} alt="Bitwarden Logo" />,
                  description: 'Bitwarden is a tool to store secrets, such as ssh keys, password etc.'
                },
                {
                  label: 'Confluence',
                  url: 'https://exxcellent.de/confluence/',
                  icon: <img style={{width: '30px', height: 'auto'}} src={ConfluenceLogoIcon} alt="Confluence Logo" />,
                  description: 'A wiki containing general and project specific documentation.'
                },
                {
                  label: 'Download Manager',
                  url: 'https://www.exxcellent.de/download-manager/admin/',
                  icon: <img src={DownloadManagerLogoIcon} alt="DownloadManager Logo" />,
                  description: 'A tool to exchange files with customers, like drop box.'
                },
                {
                  label: 'JIRA',
                  url: 'https://www.exxcellent.de/jira',
                  icon: <img style={{width: '30px', height: 'auto'}} src={JiraLogoIcon} alt="JIRA Logo" />,
                  description: 'Our tool to manage tasks, bugs and projects.'
                },
                {
                  label: 'Open Web UI',
                  url: 'https://chat.prod.ki-plattform.exxcellent.de/',
                  icon: <img style={{width: '30px', height: 'auto'}} src={OILogoIcon} alt="Open Web UI Logo" />,
                  description: 'Gives access to a chatbot to ask questions about the KI platform and its services.'
                },
                {
                  label: 'Open Secrets',
                  url: 'https://secrets.exxcellent.de/',
                  icon: <img style={{width: '30px', height: 'auto'}} src={XxLogoIconRund} alt="Open Secrets Logo" />,
                  description: 'A tool to send secret self destructive messages to customers, e.g. passwords'
                }
              ]}>
            {item => 
                (<ListRow icon={item.icon} id={item.label} description={item.description}>
                    <Link href={item.url} target='_blank'>{item.label}</Link>
                </ListRow>)}
        </List>                
  );
}
export const Content = ToolkitCard;

export const toolkitWidget = HomePageWidgetBlueprint.make({
  name: 'toolkit-widget',
  params: {
    name: 'ToolkitWidget',    
    title: 'Toolkit',
    description: 'A toolkit widget for the homepage',
    components: () =>
      import('./ToolkitCard').then(m => ({
        Content: m.Content,        
      })),      
    layout: {
      height: { minRows: 6, defaultRows: 6 },
      width: { minColumns: 3, defaultColumns: 3 },
    }    
  },
}) as  any;